import type { ColorPaletteProp } from '@mui/joy';
import Button, {
  type ButtonPropsColorOverrides,
  type ButtonPropsSizeOverrides
} from '@mui/joy/Button';
import type { OverridableStringUnion } from '@mui/types';
import type { MouseEventHandler } from 'react';

type ActionButtonProps = {
  onClick?: MouseEventHandler<HTMLButtonElement>;
  value: string;
  startDecorator?: React.ReactElement;
  endDecorator?: React.ReactElement;
  disabled?: boolean;
  size?: OverridableStringUnion<'sm' | 'md' | 'lg', ButtonPropsSizeOverrides>;
  color?: OverridableStringUnion<ColorPaletteProp, ButtonPropsColorOverrides>;
  [key: string]: unknown;
};

/** @deprecated Use `Button` from `shadcn/ui` instead, make a new variant if necessary! */
const ActionButton = ({
  onClick,
  value,
  startDecorator,
  endDecorator,
  disabled = false,
  size = 'md',
  color = 'primary',
  ...props
}: ActionButtonProps) => (
  <Button
    color={color}
    disabled={disabled}
    endDecorator={endDecorator}
    onClick={onClick}
    size={size}
    startDecorator={startDecorator}
    {...props}
  >
    {value}
  </Button>
);

export default ActionButton;
